export const COUNTRY_BR = "BR";
export const COUNTRY_AR = "AR";

export const COUNTRIES = [COUNTRY_BR, COUNTRY_AR] as const;
